<template>
  <div class="modal fade" id="addTenantAccount" data-backdrop="false" tabindex="-1" role="dialog" aria-labelledby="editRecord" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title d-inline">Add new tenant Account</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="submit">
          <div class="modal-body">
            <div class="form-group row">
              <label  class="col-sm-3 col-form-label">Name</label>
              <div class="col-sm-9">
                <input type="text" required class="form-control" v-model="name" :disabled="loading"/>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="submit" class="btn btn-primary">
              <div class="loader small_loader" v-if="loading"></div>
              <span v-else>Create</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  name: "addAccountModal",
  data () {
    return {
      loading: false,
      name: null
    }
  },
  methods: {
    async submit () {
      this.loading = true
      try {
        await this.$http.post('tenant/create-account',{
          grant_type:'token',
          name: this.name,
        });
        swal({
          title: "Message!",
          html: "You have successfully created the account.",
          type: "success",
          confirmButtonText: "OK!",
          confirmButtonColor: "#EE8057"
        });
        $('#addTenantAccount').modal('hide');
      } catch (e) {
        swal({
          title: "Something went wrong!",
          html: 'Error in creating account in CF tenant.',
          type: "error",
          confirmButtonText: "Try Again!",
          confirmButtonColor: "#EE8057"
        });
      }
      this.loading = false
      console.log('adding account')
    }
  }
}
</script>

<style scoped>

</style>